/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 

function advancedBreadcrumbsBlock(el) {

    let togglerWrapper;
    let togglerLabel;
    let togglerButton;
    let closers;
    let togglerControls; // Aria-controls value
    let submenu;
    let subMenuChildPages;
    let hasChildPages;

    let nav;
    let mousedowntime = 0;

    const breakpoints = {
        medium: 700,
        large: 1024
    }

    let currentIsMobile = isMobile();
    
    function init() {

        togglerWrapper = el;
        togglerLabel = togglerWrapper.querySelector('.label');
        togglerControls = togglerLabel.getAttribute('aria-controls');
        hasChildPages = togglerLabel.hasAttribute('data-has-child-pages');
        console.log('hasChildPages', hasChildPages);

        togglerLabel.removeAttribute('aria-controls');
        togglerLabel.removeAttribute('aria-expanded');
        togglerLabel.removeAttribute('data-has-child-pages');

        togglerButton = createToggler(togglerControls, hasChildPages, togglerLabel.textContent);
        togglerButton.setAttribute('aria-expanded', 'false'); 
        
        submenu = document.getElementById(togglerControls);

        if (submenu) {
            subMenuChildPages = submenu.querySelectorAll('.child-page-nav');
        }

        closers = [].slice.call(document.querySelectorAll(`.child-page__close[aria-controls="${togglerControls}"`));

        togglerButton.addEventListener('click', handleNavToggleClick);

        closers.forEach((closer) => {
            closer.addEventListener('click', closeMenu);
        });

        swapButton();
        window.addEventListener('resize', resize, true);
    }

    function handleNavToggleClick(evt) {

        let expanded = 'false' === togglerButton.getAttribute('aria-expanded') ? false : true;

        if (expanded) {
            if (!isMobile()) {
                closeMenu();
            }
        } else {
            openMenu();
        }

    }

    function checkOutsideClick(evt) {

        // Handle a click outside of the submenu when it is open
        
        if (isMobile()) {
            return;
        }

        if (subMenuChildPages && subMenuChildPages.length && !subMenuChildPages[0].contains(evt.target) && !togglerButton.contains(evt.target)) {
            console.log('evt.target.classList', evt.target.classList);
            closeMenu();
        }

    }

    function handleEscapeKey(evt) {

        if (evt.key === 'Escape') {
            closeMenu();
        }
    }

    function handleTabKey(evt) {

        // Only do this on the mobile menu
        if (window.innerWidth > breakpoints.large) {
            return;
        }
        const focusableElements = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
        const focusableContent = submenu.querySelectorAll(focusableElements);
        const firstFocusableElement = focusableContent[0];
        const lastFocusableElement = focusableContent[focusableContent.length - 1];
        const wrapper = document.querySelector('.advanced-breadcrumbs-block');
        wrapper.setAttribute('role', 'dialog');
        wrapper.setAttribute('aria-label', 'Section menu');
        if (evt.key === 'Tab') {
            if (evt.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    evt.preventDefault();
                }
            } else {
                // Tab
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    evt.preventDefault();
                }
            }
        }
    }

    function closeMenu() {
            
        if (submenu) {
            submenu.setAttribute('aria-expanded', false);
            submenu.removeAttribute('role');
            submenu.removeAttribute('aria-modal');
            submenu.removeAttribute('aria-label');
        }
        if (togglerButton) {
            togglerButton.setAttribute('aria-expanded', false);
        }
        // // Allow body to scroll
        document.body.classList.remove('no-scroll');
        
        document.body.removeEventListener('click', checkOutsideClick, true);
        document.body.removeEventListener('keydown', handleEscapeKey, true);
        document.body.removeEventListener('keydown', handleTabKey, true);

        swapButton();
        togglerButton.focus();

    }
    
    function openMenu(evt) {     
       
        if (submenu) {
            submenu.setAttribute('aria-expanded', true); 
            submenu.setAttribute('role', 'dialog');
            submenu.setAttribute('aria-modal', 'true');
            submenu.setAttribute('aria-label', 'Section menu');
        }

        if (togglerButton) {
            togglerButton.setAttribute('aria-expanded', true);
        }

        // Prevent body from scrolling
        if (window.innerWidth < 700) {
            document.body.classList.add('no-scroll');
        }
       
        document.body.addEventListener('click', checkOutsideClick, true);
        document.body.addEventListener('keydown', handleEscapeKey, true);
        document.body.addEventListener('keydown', handleTabKey, true);

        swapButton();
        togglerButton.focus();

    }

    function resize() {

        let newIsMobile = isMobile();

        console.log('newIsMobile', newIsMobile);
        console.log('currentIsMobile', currentIsMobile);

        if (newIsMobile !== currentIsMobile) {
            currentIsMobile = newIsMobile;
            swapButton();
        }

    }
    // On desktop, replace button with label
    function swapButton() {
        console.log('AdvancedBreadcrumbsBlock.swapButton()');
        togglerWrapper.innerHTML = '';

        console.log('isMobile()', isMobile());
        console.log('hasChildPages', hasChildPages);

        

       
        // Mobile and closed - button
        // Desktop and has child page - button

        // Mobile and open - label
        // Other wise - label

        if ( 
            (isMobile() && !isOpen()) || 
            (!isMobile() && hasChildPages)
        ) {
            togglerWrapper.appendChild(togglerButton);
        } else {
            togglerWrapper.appendChild(togglerLabel);
        }
    }

    function isMobile() {
        return window.innerWidth < breakpoints.large;
    }

    function isOpen() {
        console.log('submenu.getAttribute(\'aria-expanded\')', submenu.getAttribute('aria-expanded'));
        return submenu.getAttribute('aria-expanded') === 'true';
    }

    function createToggler(id, hasChildPages, label) {
        const template = `<button class="child-page__toggle"
                aria-expanded="false"
                aria-controls="${id}"
                data-test="${id}"
                data-has-child-pages="${hasChildPages.toString()}">
                <span class="label">${label}</span>

                <div class="child-page__toggle-close-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M1.74707 1.92053L13.8026 13.9761" stroke="#0B3F76" stroke-width="2" />
                        <path d="M13.8026 1.92053L1.74707 13.9761" stroke="#0B3F76" stroke-width="2" />
                    </svg>
                </div>
                <div class="child-page__toggle-open-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                        <path d="M0 11.1818V9.45451H15.5453V11.1818H0ZM0 6.86363V5.13637H15.5453V6.86363H0ZM0 2.54549V0.818237H15.5453V2.54549H0Z" fill="#0B3F76" />
                    </svg>
                </div>
            </button>`

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = template.trim();
            return tempDiv.firstChild;
    }

    init();
}

const AdvancedBreadcrumbsBlock = {
    init() {
        let togglers = [].slice.call(document.querySelectorAll(`.child-page__toggle-wrapper`));
        togglers.forEach((toggler) => {
            advancedBreadcrumbsBlock(toggler);
        });
    }
}

AdvancedBreadcrumbsBlock.init();

// export default AdvancedBreadcrumbsBlock;